import moment from 'moment'

import i18n from '../../../../App/i18n'

import { IHoliday, IApiHoliday } from './IHoliday'

class Transformer {
  static transform(data: IApiHoliday): IHoliday {
    return {
      id: data.id,
      name: data.attributes.name,
      translatedName: i18n.t(`holiday.${data.attributes.name}`),
      startsAt: moment(data.attributes.starts_at),
      endsAt: moment(data.attributes.ends_at),
    }
  }
}

export default Transformer
